import { FC, SVGProps } from 'react';

export const SpamIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.8261 5.53723C14.7923 3.82092 17.2077 3.82092 18.1739 5.53723L27.66 22.3883C28.6261 24.1046 27.4184 26.25 25.4861 26.25H6.51394C4.58159 26.25 3.37387 24.1046 4.34005 22.3883L13.8261 5.53723ZM16.9881 6.23936C16.549 5.45922 15.451 5.45922 15.0119 6.23936L5.5258 23.0904C5.08663 23.8706 5.6356 24.8457 6.51394 24.8457H25.4861C26.3644 24.8457 26.9134 23.8706 26.4742 23.0904L16.9881 6.23936Z"
			fill="currentColor"
		/>
		<path
			d="M15.9975 11C16.4494 11 16.8134 11.3944 16.8054 11.8753L16.7024 18.0275C16.6955 18.4366 16.382 18.7644 15.9975 18.7644C15.6131 18.7644 15.2996 18.4366 15.2927 18.0275L15.1897 11.8753C15.1817 11.3944 15.5457 11 15.9975 11ZM16 22C15.7234 22 15.4867 21.8971 15.2901 21.6913C15.0934 21.482 14.9968 21.2301 15.0001 20.9357C14.9968 20.6447 15.0934 20.3964 15.2901 20.1906C15.4867 19.9813 15.7234 19.8766 16 19.8766C16.27 19.8766 16.5034 19.9813 16.7 20.1906C16.8967 20.3964 16.9967 20.6447 17 20.9357C16.9967 21.1308 16.9483 21.3099 16.855 21.4731C16.765 21.6328 16.645 21.7605 16.495 21.8563C16.345 21.9521 16.18 22 16 22Z"
			fill="currentColor"
		/>
	</svg>
);
